import React from "react";
import { Link, useParams } from "react-router-dom";
import { Alert, Button } from "@mui/material";
import useExam from "../../../../hooks/useExam";
import { questionImage } from "../../../../api/services/exams";

const time = (seconds) => Math.floor(seconds / 60) + ":" + String(seconds % 60).padStart(2, "0");
export default function Exam() {
  const { Id } = useParams();
  const exam = useExam(Id);
  const data = exam.snapshot;
  if (exam.completed || exam.closed) return <main dir="rtl" className="dashboard p-12 space-y-6">
    <h1>{exam.completed ? "پایان آزمون ثبت شد." : "آزمون بسته است."}</h1>
    {exam.closed && <p>{exam.error}</p>}
    <Link to="/dashboard/exams">بازگشت به آزمون‌ها</Link>
  </main>;
  const review = Number(data?.active_question_number) < Number(data?.max_question_number);
  const blocked = exam.busy || exam.uncertain || !data || !exam.examSeconds || !exam.questionSeconds;
  return <main dir="rtl" className="dashboard min-h-screen p-xl space-y-8">
    <header className="flex flex-wrap items-center justify-between gap-4 rounded-panel bg-surface p-xl">
      <p>زمان سؤال: <bdi>{time(exam.questionSeconds)}</bdi></p>
      <p>زمان آزمون: <bdi>{time(exam.examSeconds)}</bdi></p>
      <Button disabled={exam.busy} color="warning" variant="contained" onClick={() => exam.action("finish")}>پایان آزمون</Button>
    </header>
    {exam.error && <Alert severity="error">{exam.error}</Alert>}
    {exam.busy && <p role="status">در حال همگام‌سازی…</p>}
    <Button disabled={exam.busy} onClick={() => exam.action("conf")}>همگام‌سازی با سرور</Button>
    {data && <>
      <h1 className="text-xl">سؤال {data.active_question_number}</h1>
      {data.q_text && <p>{data.q_text}</p>}
      {questionImage(data.q_img) && <img src={questionImage(data.q_img)} alt={"تصویر سؤال " + data.active_question_number} className="max-w-full" />}
      <fieldset disabled={blocked} className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <legend>گزینه پاسخ</legend>
        {[1, 2, 3, 4].map((choice) => <label key={choice} className="rounded-card border border-rule p-6">
          <input type="radio" name="answer" checked={Number(data.u_choice) === choice}
            onChange={() => exam.action("answer", choice)} /> گزینه {choice}
        </label>)}
      </fieldset>
      <Button disabled={blocked || !data.u_choice} onClick={() => exam.action("answer", null)}>پاک‌کردن پاسخ</Button>
      <Button disabled={blocked} onClick={() => exam.action(review || data.active_question_number < data.u_q_list.length ? "next" : "finish")}>
        {review ? "بازگشت به سؤال جاری" : data.active_question_number < data.u_q_list.length ? "سؤال بعدی" : "پایان آزمون"}
      </Button>
      <p>بازگشت باقی‌مانده: {data.returns}</p>
      <nav aria-label="سؤال‌های آزمون" className="flex flex-wrap gap-2">
        {data.u_q_list.map((_, index) => {
          const number = index + 1;
          return <Button key={number} aria-current={number === Number(data.active_question_number) ? "step" : undefined}
            disabled={blocked || Number(data.returns) <= 0 || number >= Number(data.active_question_number)}
            onClick={() => exam.action("return", number)}>{number}{data.u_choices_list?.[index] ? " ✓" : ""}</Button>;
        })}
      </nav>
    </>}
  </main>;
}
